import React, { forwardRef } from 'react';
import styles from './PageHeader.module.css';

export interface IPageHeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: string;
  onBack: () => void;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  /** up turns the arrow a quarter turn and lifts the button on hover, for a step back within a page. */
  backDirection?: 'left' | 'up';
  backButtonClassName?: string;
  /** Spread onto the back button, e.g. { disabled } while a submit is in flight. */
  backButtonProps?: Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'onClick'>;
}

const PageHeader = forwardRef<HTMLDivElement, IPageHeaderProps>(
  (
    {
      title,
      onBack,
      subtitle,
      actions,
      backDirection = 'left',
      backButtonClassName,
      backButtonProps,
      className,
      ...rest
    },
    ref,
  ) => {
    const up = backDirection === 'up';
    const buttonClasses = [styles.backButton, up && styles.up, backButtonClassName];
    const iconClasses = [styles.backIcon, up && styles.upIcon];

    return (
      <div ref={ref} className={`${styles.header} ${className || ''}`} {...rest}>
        <div className={styles.headerRow}>
          <button
            {...backButtonProps}
            className={buttonClasses.filter(Boolean).join(' ')}
            onClick={onBack}
          >
            <span className={iconClasses.filter(Boolean).join(' ')}>&larr;</span>
            {title}
          </button>
          {actions && <div className={styles.actions}>{actions}</div>}
        </div>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
    );
  },
);

PageHeader.displayName = 'PageHeader';

export default PageHeader;
